<template>
	<div class="container">

		<div class="row mb-8">
			<div class="col-12">
				<h1>{{ $t('new-form') }}</h1>
			</div>
		</div>

		<div class="row mb-8">
			<div class="col-12 col-lg-8">
				<SelectInput
					:label="$t('workflows')"
					:options="workflows"
					optionLabel="title"
					v-model="selectedWorkflow"
					@input="getWorkflowDetails()"
				/>
			</div>
		</div>

		<template v-if="selectedWorkflow">
			<div class="row mb-8">
				<div class="col-12 col-lg-8">
					<SelectInput
						:label="$t('form')"
						:options="selectedWorkflow.forms"
						optionValue="id"
						optionLabel="title"
						v-model="selectedForm"
					/>
				</div>
			</div>

			<template v-if="selectedForm">
				<div class="row" v-if="isTeacher && students.length">
					<div class="col-12 col-lg-8">
						<div class="clearfix mb-4">
							<div class="pseudo-input" :class="{error:recipientsError}">
								<input
									type="search"
									class="input-bare w-full flex-1"
									:placeholder="$t('for-users')"
									v-if="!recipients.length"
									@click="openStudentsModal"
								/>
								<span
									class="badge badge-secondary badge-sm mr-2 mb-2"
									v-for="(recipient, index) in recipients"
									v-bind:key="index"
								>
									{{ recipient.displayName }}
									<a @click="removeRecipient(recipient)"><b-icon icon="x"></b-icon></a>
								</span>
								<span
									class="badge badge-primary badge-sm mr-2 mb-2"
									v-if="recipients.length"
									@click="openStudentsModal"
								>
									<b-icon icon="plus"></b-icon> {{ $t('add') }}
								</span>
								<span
									class="badge badge-danger badge-sm mr-2 mb-2"
									v-if="recipients.length"
									@click="recipients=[]"
								>
									<b-icon icon="x"></b-icon> {{ $t('clear-all') }}
								</span>
							</div>
							<span class="text-error" v-if="recipientsError">{{ $t('please-select-at-least-one-user') }}</span>
						</div>
						<div class="clearfix" v-if="$UserSession.hasPriv('TREATMENTSESSION_MANAGE')">
							<template v-for="programme in $config.getValue('programmes')">
								<button
									class="btn btn-info mr-2 mb-4"
									v-for="year in parseInt(programme.CourseLengthYears) + 1"
									:key="`${programme.Name}-${year}`"
									@click="
										addRecipientsBy({ programme: programme.Id, year: year.toString() })
									"
								>
									{{ programme.Name }}
									<template v-if="year <= parseInt(programme.CourseLengthYears)">
										{{ $t("year") }} {{ year }}
									</template>
									<template v-else>{{ $t('graduated') }}</template>
								</button>
							</template>

							<button
								class="btn btn-info mr-2 mb-4"
								@click="addRecipientsBy({ isStudent: true })"
							>
								{{ $tc("all-students", 1) }}
							</button>
						</div>
					</div>
				</div>

				<div class="row" v-if="this.$config.getValue('workbooks').length">
					<div class="col-12 col-lg-8">
						<label for="form">{{$t('workbooks')}}</label>
						<div class="clearfix">
							<div class="pseudo-input mb-4">
								<input
									type="search"
									class="input-bare w-full flex-1"
									:placeholder="$t('workbooks')"
									v-if="!workbooks.length"
									@click="openWorkbooksModal"
								/>
								<span
									class="badge badge-secondary badge-sm mr-2 mb-2"
									v-for="(workbook, index) in workbooks"
									v-bind:key="index"
								>
									{{ workbook.title }}
									<a @click="removeWorkbook(workbook)"><b-icon icon="x"></b-icon></a>
								</span>
								<span
									class="badge badge-primary badge-sm mr-2 mb-2"
									v-if="workbooks.length"
									@click="openWorkbooksModal"
								>
									<b-icon icon="plus"></b-icon> {{ $t('add') }}
								</span>
							</div>
						</div>
					</div>
				</div>

				<div class="row mb-8">
					<div class="col-12 col-lg-8">

						<div class="form-group" v-if="selectedWorkflow && selectedWorkflow.hassubject==true">
							<label>{{ $t('about') }}</label>
							<input
								type="text"
								:value="(usersubject?usersubject.displayname:null)"
								class="form-control"
								:class="{error:usersubjectError}"
								@focus="selectSubjectUser"
								:placeholder="$t('none')"
							/>
							<span class="text-error" v-if="usersubjectError">{{$t('select')}}</span>
						</div>

						<div class="form-group" v-if="selectedWorkflow && selectedWorkflow.requirereview==true">
							<label>{{ $t('review-from') }}</label>
							<input
								type="text"
								:value="(reviewFrom?reviewFrom.displayname:null)"
								class="form-control"
								:class="{error:reviewFromError}"
								@focus="selectReview"
								:placeholder="$t('none')"
							/>
							<span class="text-error" v-if="reviewFromError">{{$t('select')}}</span>
						</div>

						<div class="form-group" v-if="signers.length > 0">
							<label>{{ $t('sign-off') }}</label>
							<input
								type="text"
								:value="(signoffFrom?signoffFrom.displayname:null)"
								class="form-control"
								:class="{error:signoffFromError}"
								@focus="selectSignoff"
								:placeholder="$t('none')"
							/>
							<span class="text-error" v-if="signoffFromError">{{$t('select')}}</span>
						</div>

						<template v-if="isTeacher">
							<div class="form-group">
								<label id="publication-date">{{ $t('publication-date') }}</label>
								<input class="form-control" type="datetime-local" id="publication-date" name="publication-date" v-model="publicationDate">
							</div>

							<div class="form-group">
								<label for="deadline">{{ $t('deadline') }}</label>
								<input class="form-control" type="datetime-local" id="deadline" name="deadline" v-model="deadline">
							</div>

							<div class="form-group">
								<label for="message">{{ $t('message') }}</label>
								<textarea class="form-control" id="message" v-model="message"></textarea>
							</div>
						</template>

						<button class="btn btn-primary" @click="submit">{{ $t('submit') }}</button>

					</div>
				</div>
			</template>

		</template>

	</div>
</template>

<script>
import { ValidateMixin } from '@/mixins';
export default {
	mixins: [ValidateMixin],
	data: function () {
		return {
			workflows: [],
			selectedWorkflow: null,
			selectedForm: null,
			students: [],
			reviewers: [],
			signers: [],
			recipients: [],
			recipientsError: false,
			reviewFromError: false,
			usersubjectError: false,
			usersubject: {
				id: null,
				displayname: null
			},
			reviewFrom: {
				id: null,
				displayname: null
			},
			signoffFromError: false,
			signoffFrom: {
				id: null,
				displayname: null
			},
			workbooks: [],
			publicationDate: null,
			deadline: null,
			message: null
		}
	},
	mounted() {
  		this.publicationDate = this.$datetime.getDateTimeLocalFieldNowValue();
		this.getWorkflows();
		/*
		//this.getTeachers();
		if(this.isTeacher) {
			this.getStudents();
		}
		this.getForms();
  		if(this.$route.query.workbookid){
  			this.$config.getValue('workbooks').forEach(workbook =>{
  				if(workbook.id == this.$route.query.workbookid){
  					this.workbooks.push(workbook);
  				}
  			})
  		}
  		*/
	},
	methods: {
		getWorkflows() {

			this.$cfetch(`${this.$settings.APIBaseURL}/workflows/assignable`)
			.then((json) => {
				if (json.status == 'SUCCESS') {
					json.results.forEach(item => {
						if(item.forms.length){
                            item.forms.sort((x, y) => {
                                // Order alphabetically
                                let X = x.title.toLowerCase();
                                let Y = y.title.toLowerCase();

                                if (X < Y) return -1;
                                if (X > Y) return 1;
                                return 0;
                            });
							item.title = item.workflow.title;
							this.workflows.push(item);
						}
					});
					/*
					this.workflows = json.results.reduce(item => {
						if(item.forms.length){
							item.title = item.workflow.title;
							return item;
						}
					});
					*/
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		getWorkflowDetails() {
			this.getSubmitters();
			this.getSubjectUsers();
			this.getReviewers();
			this.getSigners();
		},
		getSubmitters() {
			this.$users.getStudents.call(this).then((students) => {
				this.students = students;
			});
		},
		getSubjectUsers() {
			this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/selectformroleuser/subject`, {
				data: {
					workflowstage_id: this.selectedWorkflow.id
				}
			})
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.subjectusers = json.users;
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		getReviewers() {
			this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/selectformroleuser/review`, {
				data: {
					workflowstage_id: this.selectedWorkflow.id
				}
			})
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.reviewers = json.users;
					if(this.isTeacher) {
						// preselect self in "approval from" field
						//this.reviewFrom.id = this.$UserSession.getValue('id');
						//this.reviewFrom.title = this.$UserSession.getValue('displayName');
					}
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		getSigners() {
			this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/selectformroleuser/signoff`, {
				data: {
					workflowstage_id: this.selectedWorkflow.id
				}
			})
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.signers = json.users;
					if(this.isTeacher) {
						// preselect self in "approval from" field
						this.signoffFrom.id = this.$UserSession.getValue('id');
						this.signoffFrom.displayname = this.$UserSession.getValue('displayName');
					}
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		submit() {

        	this.validate();

        	this.recipientsError = !this.recipients.length && this.isTeacher;
        	this.usersubjectError = (!this.usersubject || !this.usersubject.id) && this.form && this.form.hassubject == '1';
        	this.reviewFromError = (!this.reviewFrom || !this.reviewFrom.id) && this.form && this.form.requirereview == '1';
        	this.signoffFromError = (!this.signoffFrom || !this.signoffFrom.id) && this.form && this.form.requiresignoff == '1';

        	// todo: would like to integrate this into v-validate somehow
        	if (this.hasErrors || this.recipientsError || this.reviewFromError || this.signoffFromError || this.usersubjectError) {
        		return false;
        	}

    		this.$store.commit("showBlockingSpinner");

    		const data = {
				workflowstage_id: this.selectedWorkflow.id,
				form_id: this.selectedForm,
				workbooks: this.workbooks,
				recipients: this.recipients,
				usersubject_id: (this.selectedWorkflow.hassubject?(this.usersubject?this.usersubject.id:null):null),
				userreview_id: (this.selectedWorkflow.requirereview?(this.reviewFrom?this.reviewFrom.id:null):null),
				usersignofffrom_id: (this.signoffFrom?this.signoffFrom.id:null),
				publicationdate: this.$datetime.getTimeStampFromDateTimeField(this.publicationDate),
				deadline: null,
				message: this.message
  			}
  			if(this.deadline) {
  				data.deadline = this.$datetime.getTimeStampFromDateTimeField(this.deadline);
  			}

  			this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/assign`, {
  				method: 'post',
  				data
  			})
			.then(json => {
				if (json.status == 'SUCCESS') {
					this.$store.commit("hideBlockingSpinner");
					// form saved
					if(!this.isTeacher ||
						(
							this.recipients.length == 1 &&
							(
								(data.usersignofffrom_id && data.usersignofffrom_id == this.$UserSession.getValue('id'))
								||
								(data.userreview_id && data.userreview_id == this.$UserSession.getValue('id'))
							)
						)
					) {
						// go to form
						this.$router.replace(`/forms/view/${json.formresponse.id}`);
					} else {
						// go back to form list
						this.$store.commit("openDialog", {
							title: this.$t("saved"),
							content: this.$t("form-saved"),
							confirmCallBack: function() {
								this.$router.replace(`/forms`);
							}
						});
					}
				} else {
					// something went wrong
					this.$store.commit("hideBlockingSpinner");
				}
			}).catch(error => {
				this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
			});
		},
		addRecipientsBy(filter) {
			this.recipients = [
				...this.recipients,
				...this.students.filter(students => {
					for (let key in filter) {
						if (students[key] === undefined || students[key] != filter[key]) return false;
					}
					return !this.recipients.some(
						recipient => recipient.id == students.id // don't add recipients that have already been added
					);
				})
			];
		},
		openStudentsModal() {
			const self = this
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t('select-recipients'),
				selectCallback: function(selection) {
					const isSelected = self.recipients.find(
						(recipient, i) => {
							if(recipient.id === selection.id){
								self.$delete(self.recipients, i);
								return true;
							}
						}
					);
					if (!isSelected) {
						self.recipients.push(selection);
					}
					self.recipientsError = false;
				},
				selected: this.recipients,
				data: this.students,
				captionKey: 'displayName',
				studentSearchFilters: true,
				selectAllBtn: true
			});
		},
		removeRecipient(selection) {
			const self = this
			self.recipients.find(
				(student, i) => {
					if(student.id === selection.id){
						self.$delete(self.recipients, i);
						return true;
					}
				}
			);
			return false;
		},
		formSelected(){
			this.getSubjectUsers();
			this.getReviewers();
			this.getSigners();
		},
		selectSubjectUser(){
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t('select'),
				selectCallback: function(selection) {
					if(self.usersubject && self.usersubject.id === selection.id){
						self.usersubject = null;
					} else {
						self.usersubject = selection;
					}
					self.$store.commit("closeModal");
				},
				selected: [{
					id: (this.usersubject?this.usersubject.id:null)
				}],
				data: this.subjectusers,
				captionKey: 'displayname'
			});
		},
		selectReview(){
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t('select'),
				selectCallback: function(selection) {
					if(self.reviewFrom && self.reviewFrom.id === selection.id){
						self.reviewFrom = null;
					} else {
						self.reviewFrom = selection;
					}
					self.$store.commit("closeModal");
				},
				selected: [{
					id: (this.reviewFrom?this.reviewFrom.id:null)
				}],
				data: this.reviewers,
				captionKey: 'displayname'
			});
		},
		selectSignoff(){
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t('select'),
				selectCallback: function(selection) {
					if(self.signoffFrom && self.signoffFrom.id === selection.id){
						self.signoffFrom = null;
					} else {
						self.signoffFrom = selection;
					}
					self.$store.commit("closeModal");
				},
				selected: [{
					id: (this.signoffFrom?this.signoffFrom.id:null)
				}],
				data: this.signers,
				captionKey: 'displayname'
			});
		},
		openWorkbooksModal() {
			const self = this
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t('select-workbooks'),
				selectCallback: function(selection) {
					const isSelected = self.workbooks.find(
						(workbook, i) => {
							if(workbook.id === selection.id){
								self.$delete(self.workbooks, i);
								return true;
							}
						}
					);
					if (!isSelected) {
						self.workbooks.push(selection);
					}
				},
				selected: this.workbooks,
				data: this.$config.getValue('workbooks'),
				captionKey: 'title'
			});
		},
		removeWorkbook(selection) {
			const self = this
			self.workbooks.find(
				(workbook, i) => {
					if(workbook.id === selection.id){
						self.$delete(self.workbooks, i);
						return true;
					}
				}
			);
			return false;
		}
	},
	computed: {
		isTeacher() {
			return this.$UserSession.hasPriv.call(this, 'MARK_TREATMENTSESSIONS');
		}
	}
};
</script>
